/* McKeever Sports "Find your club" (sections/ms-club-finder.liquid).
   Looks up collections with Shopify's predictive search as the shopper types and
   lists them as links, with the collection image (club crest) where there is one. */
if (!customElements.get('ms-club-finder')) {
  customElements.define(
    'ms-club-finder',
    class MsClubFinder extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-ms-cf-input]');
        this.results = this.querySelector('[data-ms-cf-results]');
        this.status = this.querySelector('[data-ms-cf-status]');
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(), 200);
        });
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            const first = this.results.querySelector('a');
            if (first) {
              event.preventDefault();
              first.focus();
            }
          }
        });
        this.results.addEventListener('keydown', (event) => {
          const links = Array.from(this.results.querySelectorAll('a'));
          const i = links.indexOf(document.activeElement);
          if (event.key === 'ArrowDown' && links[i + 1]) {
            event.preventDefault();
            links[i + 1].focus();
          }
          if (event.key === 'ArrowUp') {
            event.preventDefault();
            (links[i - 1] || this.input).focus();
          }
        });
      }

      search() {
        const q = this.input.value.trim();
        if (this.controller) this.controller.abort();
        if (q.length < 2) {
          this.results.hidden = true;
          this.results.innerHTML = '';
          this.status.textContent = '';
          return;
        }
        this.controller = new AbortController();
        const url =
          this.dataset.url +
          '.json?q=' +
          encodeURIComponent(q) +
          '&resources[type]=collection&resources[limit]=10';
        fetch(url, { signal: this.controller.signal })
          .then((response) => response.json())
          .then((data) => this.render((data.resources && data.resources.results.collections) || []))
          .catch(() => {});
      }

      render(collections) {
        const list = this.results;
        list.innerHTML = '';
        if (!collections.length) {
          const li = document.createElement('li');
          li.className = 'ms-cf__none';
          li.textContent = list.dataset.none;
          list.appendChild(li);
        }
        collections.forEach((c) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'ms-cf__result';
          a.href = c.url;
          const media = document.createElement('span');
          media.className = 'ms-cf__crest';
          media.setAttribute('aria-hidden', 'true');
          const src = c.featured_image && c.featured_image.url;
          if (src) {
            const img = document.createElement('img');
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
            img.alt = '';
            img.width = 48;
            img.height = 48;
            img.loading = 'lazy';
            media.appendChild(img);
          } else {
            media.textContent = c.title.charAt(0);
          }
          const name = document.createElement('span');
          name.className = 'ms-cf__name';
          name.textContent = c.title;
          a.append(media, name);
          li.appendChild(a);
          list.appendChild(li);
        });
        list.hidden = false;
        const n = collections.length;
        this.status.textContent = (n === 1 ? list.dataset.countOne : list.dataset.countOther).replace('[count]', n);
      }
    }
  );
}
